export default __webpack_public_path__ + "static/embie-with-text-77b321e5acf56c315cd54c4d9ec43589.png";